import React from 'react';
import useStyleStore from '../store/useStyleStore';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiX } = FiIcons;

const StyleSelectionDialog = ({ isOpen, onClose, onConfirm }) => {
  const { styles } = useStyleStore();

  if (!isOpen) return null;

  const handleSelect = (styleId) => {
    onConfirm(styleId);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl p-6">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Wybierz styl projektu</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          {styles.map(style => (
            <button
              key={style.id}
              onClick={() => handleSelect(style.id)}
              className="group relative p-4 border-2 border-gray-100 rounded-xl text-left hover:border-[#1E2937] transition-all bg-gray-50 hover:bg-white"
            >
              <div className="h-24 bg-white border border-gray-200 rounded-lg mb-3 flex items-center justify-center overflow-hidden relative shadow-sm">
                 {/* Preview */}
                 <div className="absolute inset-0 opacity-50" style={{ backgroundColor: style.rooms.fillColor }}></div>
                 <div className="w-16 h-16 border-4 z-10" style={{ borderColor: style.walls.color, backgroundColor: style.rooms.fillColor }}></div>
              </div>
              <h3 className="font-bold text-gray-800">{style.name}</h3>
            </button>
          ))}
        </div>
        <div className="flex justify-end">
             <button onClick={onClose} className="px-4 py-2 text-gray-500 hover:text-gray-700 font-medium">Anuluj</button>
        </div>
      </div>
    </div>
  );
};

export default StyleSelectionDialog;